export default __webpack_public_path__ + "static/media/Cage1.50a05273.svg";